import {
	Box,
	Card,
	CardContent,
	makeStyles, TextField,
	Typography
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import EditGroupDialog from './EditGroupDialog';
import RemoveGroupDialog from './RemoveGroupDialog';

const useStyles = makeStyles((theme) => ({
	root: {},
	importButton: {
		marginRight: theme.spacing(1)
	},
	exportButton: {
		marginRight: theme.spacing(1)
	},
	formControl: {
		minWidth: 300
	}
}));

const Toolbar = (props) => {
	const classes = useStyles();
	let set_select_filter = props.select_filter;
	const [group, setGroup] = React.useState('');
	const rows = props.rows;
	// const rows = [];

	const reset = () => {
		setGroup('')
		set_select_filter(null);
	}
	const handle_select = (e) => {
		setGroup(e.target.value)
		set_select_filter(e.target.value);
		// console.log(e.target.value);
	}

	return (
		<div>

			<Box
				display="flex"
				justifyContent="flex-end"
			>
			</Box>
			<Box mt={3}>
				<Card>
					<CardContent>
						<Box maxWidth={500}>
							{
								rows.length === 0 ?
									<Typography>
										Please Create a Group First
									</Typography>
									:
									<div style={{ display: 'flex', flexGrow: 1 }}>
										<TextField
											id="outlined-select-group"
											select
											error={group === "" ? true : false}
											label="Select a Group"
											value={group}
											onChange={handle_select}
											helperText={group === "" ? "Please select a Group" : null}
											variant="outlined"
											className={classes.formControl}
										>
											{/* <MenuItem value=""></MenuItem> */}
											{
												rows.map((row, index) => {
													return (
														<MenuItem key={index} value={index}>{row.name}</MenuItem>
													)
												})
											}
										</TextField>
										{
											group !== '' ?
												<div style={{ display: 'flex', flexGrow: 1, paddingLeft: '22px', paddingTop: '5px' }}>
													<EditGroupDialog group={rows[group]} />
													<div style={{ paddingLeft: '22px' }} />
													<RemoveGroupDialog reset={reset} group={rows[group]} />
												</div>
												:
												null
										}
									</div>
							}
						</Box>
					</CardContent>
				</Card>
			</Box>
		</div>
	);
};

Toolbar.propTypes = {
	className: PropTypes.string,
};

export default Toolbar;
